var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#EDD8F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7994 25.8003C24.7651 25.8003 23.7731 26.2112 23.0417 26.9426C22.3103 27.674 21.8994 28.6659 21.8994 29.7003V37.5003C21.8994 38.5346 22.3103 39.5266 23.0417 40.258C23.7731 40.9894 24.7651 41.4003 25.7994 41.4003V29.7003H45.2994C45.2994 28.6659 44.8885 27.674 44.1571 26.9426C43.4257 26.2112 42.4338 25.8003 41.3994 25.8003H25.7994ZM29.6994 37.5003C29.6994 36.4659 30.1103 35.474 30.8417 34.7426C31.5731 34.0112 32.5651 33.6003 33.5994 33.6003H49.1994C50.2338 33.6003 51.2257 34.0112 51.9571 34.7426C52.6885 35.474 53.0994 36.4659 53.0994 37.5003V45.3003C53.0994 46.3346 52.6885 47.3266 51.9571 48.058C51.2257 48.7894 50.2338 49.2003 49.1994 49.2003H33.5994C32.5651 49.2003 31.5731 48.7894 30.8417 48.058C30.1103 47.3266 29.6994 46.3346 29.6994 45.3003V37.5003ZM41.3994 45.3003C42.4338 45.3003 43.4257 44.8894 44.1571 44.158C44.8885 43.4266 45.2994 42.4346 45.2994 41.4003C45.2994 40.3659 44.8885 39.374 44.1571 38.6426C43.4257 37.9112 42.4338 37.5003 41.3994 37.5003C40.3651 37.5003 39.3731 37.9112 38.6417 38.6426C37.9103 39.374 37.4994 40.3659 37.4994 41.4003C37.4994 42.4346 37.9103 43.4266 38.6417 44.158C39.3731 44.8894 40.3651 45.3003 41.3994 45.3003Z",
    fill: "#9C27CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.6b16cad706039ce5766a5e19a35a6c3a.svg";
export { ForwardRef as ReactComponent };